import React, { Component } from 'react'

import { Breadcrumb, Card, Layout, message, Row } from 'antd'
import GovernmentsApi from '../../api/Governments'
import { Link } from 'react-router-dom'

import style from './style.css'
import { strVal } from '../../modules/Utils'
import CustomTable from '../../elements/Table/CustomTable'

const { Content } = Layout

class Governments extends Component {
  api = new GovernmentsApi()
  state = {
    list: [],
    data: [],
    fetching: false,
    searchWord: '',
  }
  pagination = {
    pageSize: 8,
    showSizeChanger: true,
    pageSizeOptions: ['12', '24', '30', '60'],
    showTotal: total => {
      return `${total} Record`
    },
  }
  columns = [
    {
      Header: 'Code',
      accessor: 'code',
      width: 100,
    },
    {
      Header: 'Full Name',
      accessor: 'fn',
      Cell: ({ original, value }) => (
        <Link to={`/corporates/governments/${original._key}`}>{value}</Link>
      ),
      width: 500,
    },
    {
      Header: 'Email',
      accessor: 'email.label',
    },
    {
      Header: 'Phone',
      accessor: 'phone.label',
    },
    {
      Header: 'Operation',
      accessor: 'status',
    },
  ]

  componentDidMount () {
    this.fetch()
  }

  filterOnChange = e => {}

  fetch = async () => {
    try {
      this.setState({ fetching: true })
      let list = await this.api.list()
      this.setState({ data: list, list, fetching: false })
    } catch (err) {
      message.error(err.errorMessage)
      this.setState({ fetching: false })
    }
  }

  handleOnSearch = e => {
    let filtered = this.state.data
      .map(a => a)
      .filter(row => {
        return (
          strVal(row, 'fn')
            .toUpperCase()
            .includes(e.target.value.toUpperCase()) ||
          strVal(row, 'email.label')
            .toUpperCase()
            .includes(e.target.value.toUpperCase())
        )
      })
    this.setState({ list: filtered, searchWord: e.target.value })
  }

  render () {
    return (
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item href="#/corporates/">Corporates</Breadcrumb.Item>
              <Breadcrumb.Item>Governments List</Breadcrumb.Item>
            </Breadcrumb>
            <h2 className={style.title}>Governments</h2>
            <p className={style.paragraph}>
              List of all Governments in system. You can filter or create a new
              government.
            </p>
          </Row>
        </Card>
        <Card>
          <CustomTable
            isFilterable={true}
            fetch={this.fetch}
            loading={this.state.fetching}
            columns={this.columns}
            data={this.state.list}
          />
        </Card>
      </Content>
    )
  }
}

Governments.propTypes = {}
Governments.defaultProps = {}

export default Governments
